<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
    <g id="freepik--background-complete--inject-7">
      <path
        d="M408.11,144.16l10.53,6.53,2-3.22a2.94,2.94,0,0,1,2.77-1.37c.62.05,1.23.07,1.85.06a2.93,2.93,0,0,1,2.68,1.53l1.79,3.35,10.92-5.86-1.79-3.34a3,3,0,0,1,.2-3.08c.35-.51.68-1,1-1.58a2.92,2.92,0,0,1,2.67-1.55l3.79.12.39-12.39-3.81-.11a2.93,2.93,0,0,1-2.56-1.73c-.13-.27-.27-.54-.41-.81s-.3-.54-.46-.8a3,3,0,0,1,0-3.07l2-3.25-10.53-6.53-2,3.23a2.94,2.94,0,0,1-2.78,1.36c-.61-.05-1.22-.07-1.84-.06a3,3,0,0,1-2.67-1.54l-1.8-3.34-10.92,5.86,1.79,3.34a3,3,0,0,1-.19,3.08,15.09,15.09,0,0,0-1,1.57,2.94,2.94,0,0,1-2.68,1.55l-3.8-.11-.38,12.38,3.8.12a3,3,0,0,1,2.56,1.72c.13.28.26.55.41.83s.29.53.45.79a2.94,2.94,0,0,1,0,3.09Zm7.82-10.49a10.15,10.15,0,1,1,13.74,4.16A10.15,10.15,0,0,1,415.93,133.67Z"
        style="fill:#ebebeb"
      ></path>
      <path
        d="M397.81,193.65l4.34,7.52,2.3-1.33a2,2,0,0,1,2.17.07,11.27,11.27,0,0,0,1.12.65,2,2,0,0,1,1.14,1.83v2.66h8.69v-2.66a2,2,0,0,1,1.14-1.83,11.27,11.27,0,0,0,1.12-.65,2,2,0,0,1,2.17-.07l2.3,1.33,4.34-7.52-2.31-1.34a2.05,2.05,0,0,1-1-1.91c0-.21,0-.43,0-.64s0-.43,0-.64a2.06,2.06,0,0,1,1-1.91l2.32-1.33-4.34-7.52L422,179.69a2.05,2.05,0,0,1-2.16-.08c-.36-.23-.74-.45-1.12-.65a2,2,0,0,1-1.14-1.83v-2.66h-8.69v2.66a2,2,0,0,1-1.14,1.83c-.38.2-.75.42-1.11.65a2.07,2.07,0,0,1-2.17.08l-2.31-1.33-4.34,7.52,2.31,1.33a2.05,2.05,0,0,1,1,1.91c0,.21,0,.42,0,.64s0,.43,0,.64a2.08,2.08,0,0,1-1,1.92Zm8.3-3.89a7.12,7.12,0,1,1,7.11,7.12A7.11,7.11,0,0,1,406.11,189.76Z"
        style="fill:#ebebeb"
      ></path>
      <path
        d="M51.27,279.62l4.34,7.52,2.3-1.33a2.05,2.05,0,0,1,2.16.08c.37.23.74.45,1.13.65a2.06,2.06,0,0,1,1.14,1.83V291H71v-2.66a2,2,0,0,1,1.15-1.83c.38-.2.76-.42,1.12-.65a2.05,2.05,0,0,1,2.16-.08l2.31,1.33,4.33-7.52-2.31-1.33a2.05,2.05,0,0,1-1-1.91c0-.21,0-.43,0-.64s0-.43,0-.64a2.05,2.05,0,0,1,1-1.91l2.31-1.34-4.33-7.52-2.31,1.33a2,2,0,0,1-2.17-.07,11.27,11.27,0,0,0-1.12-.65A2.06,2.06,0,0,1,71,263.11v-2.66H62.34v2.66a2.06,2.06,0,0,1-1.14,1.83,11.27,11.27,0,0,0-1.12.65,2,2,0,0,1-2.16.07l-2.31-1.33-4.34,7.52,2.31,1.34a2.08,2.08,0,0,1,1,1.9c0,.22,0,.43,0,.65s0,.43,0,.64a2.06,2.06,0,0,1-1,1.91Zm8.3-3.88a7.11,7.11,0,1,1,7.11,7.11A7.11,7.11,0,0,1,59.57,275.74Z"
        style="fill:#ebebeb"
      ></path>
      <rect
        x="47.54"
        y="45.3"
        width="131.75"
        height="202.02"
        style="fill:#ebebeb"
      ></rect>
      <rect
        x="54.72"
        y="53.39"
        width="55.64"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <rect
        x="116.49"
        y="53.39"
        width="55.63"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <rect
        x="54.72"
        y="149.37"
        width="55.64"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <rect
        x="116.49"
        y="149.37"
        width="55.63"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <polygon
        points="88.41 53.39 54.72 87.08 54.72 67.2 68.54 53.39 88.41 53.39"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="54.72 235.91 110.36 180.27 110.36 200.13 71.27 239.23 54.72 239.23 54.72 235.91"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="161.13 149.37 116.48 194.02 116.48 174.15 141.26 149.37 161.13 149.37"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="172.12 118.52 172.12 138.38 167.25 143.25 147.38 143.25 172.12 118.52"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="172.12 218.41 172.12 238.28 171.17 239.23 151.31 239.23 172.12 218.41"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="57.91 149.37 67.84 149.37 54.72 162.49 54.72 152.55 57.91 149.37"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="64.03 143.25 110.36 96.91 110.36 106.84 73.96 143.25 64.03 143.25"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="163.82 53.39 116.48 100.72 116.48 90.79 153.89 53.39 163.82 53.39"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="104.74 53.39 54.72 103.41 54.72 100.92 102.25 53.39 104.74 53.39"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="85.82 239.23 110.36 214.68 110.36 217.17 88.31 239.23 85.82 239.23"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="172.12 152.94 172.12 155.41 116.48 211.05 116.48 208.56 172.12 152.94"
        style="fill:#ebebeb"
      ></polygon>
      <rect
        x="208.89"
        y="45.3"
        width="131.75"
        height="202.02"
        style="fill:#ebebeb"
      ></rect>
      <rect
        x="216.07"
        y="53.39"
        width="55.64"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <rect
        x="277.83"
        y="53.39"
        width="55.63"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <rect
        x="216.07"
        y="149.37"
        width="55.64"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <rect
        x="277.83"
        y="149.37"
        width="55.63"
        height="89.86"
        style="fill:#fff"
      ></rect>
      <polygon
        points="216.07 149.37 221.31 149.37 216.07 154.61 216.07 149.37"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="216.07 134.74 271.71 79.09 271.71 98.97 227.43 143.25 216.07 143.25 216.07 134.74"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="317.29 53.39 277.83 92.85 277.83 72.97 297.41 53.39 317.29 53.39"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="333.46 178.55 333.46 198.42 292.66 239.23 277.83 239.23 277.83 234.18 333.46 178.55"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="271.71 53.39 271.71 55.23 216.07 110.87 216.07 100.93 263.6 53.39 271.71 53.39"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="249.63 239.23 271.71 217.15 271.71 227.08 259.56 239.23 249.63 239.23"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="333.46 155.39 333.46 165.33 277.83 220.96 277.83 211.03 333.46 155.39"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="228.07 149.37 230.56 149.37 216.07 163.86 216.07 161.38 228.07 149.37"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="234.19 143.25 271.71 105.73 271.71 108.22 236.68 143.25 234.19 143.25"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="326.54 53.39 277.83 102.1 277.83 99.61 324.05 53.39 326.54 53.39"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="216.07 237.36 271.71 181.72 271.71 184.2 216.68 239.23 216.07 239.23 216.07 237.36"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="306.54 149.37 277.83 178.08 277.83 175.6 304.05 149.37 306.54 149.37"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="333.46 119.96 333.46 122.45 312.66 143.25 310.17 143.25 333.46 119.96"
        style="fill:#ebebeb"
      ></polygon>
    </g>
    <g id="freepik--Floor--inject-7">
      <polygon
        points="33.4 403.49 87.55 403.25 141.7 403.16 250 402.99 358.3 403.16 412.45 403.25 466.6 403.49 412.45 403.74 358.3 403.82 250 403.99 141.7 403.82 87.55 403.74 33.4 403.49"
        style="fill:#263238"
      ></polygon>
    </g>
    <g id="freepik--Clock--inject-7">
      <polygon
        points="142.67 389.23 128.41 427.7 145.15 427.7 176.15 406.58 142.67 389.23"
        style="fill:#2C70B7"
      ></polygon>
      <polygon
        points="142.67 389.23 128.41 427.7 145.15 427.7 176.15 406.58 142.67 389.23"
        style="opacity:0.1"
      ></polygon>
      <polygon
        points="357.33 389.23 371.59 427.7 354.85 427.7 323.85 406.58 357.33 389.23"
        style="fill:#2C70B7"
      ></polygon>
      <polygon
        points="357.33 389.23 371.59 427.7 354.85 427.7 323.85 406.58 357.33 389.23"
        style="opacity:0.1"
      ></polygon>
      <circle
        cx="250"
        cy="260"
        r="171.05"
        transform="translate(-110.62 252.93) rotate(-45)"
        style="fill:#2C70B7"
      ></circle>
      <circle cx="247.92" cy="257.19" r="163.22" style="opacity:0.1"></circle>
      <circle
        cx="250"
        cy="259.27"
        r="152.91"
        transform="translate(-110.11 252.72) rotate(-45)"
        style="fill:#fff"
      ></circle>
      <path
        d="M399.42,226.79c-69.63,42.19-184.07,111.4-248,149.34a153,153,0,0,1-41.79-56.19L321.16,123.88A153.06,153.06,0,0,1,399.42,226.79Z"
        style="fill:#ebebeb"
      ></path>
      <path
        d="M402.78,264.58a151.57,151.57,0,0,1-10.11,49.69L202,404.46a151.37,151.37,0,0,1-24.09-10.35C235.48,360.82,340.76,300.25,402.78,264.58Z"
        style="fill:#ebebeb"
      ></path>
      <rect
        x="248.52"
        y="117.46"
        width="2.95"
        height="23.18"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="183.41"
        y="134.9"
        width="2.96"
        height="23.18"
        transform="translate(-48.47 112.06) rotate(-30)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="135.75"
        y="182.57"
        width="2.95"
        height="23.18"
        transform="translate(-99.54 215.9) rotate(-60)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="108.19"
        y="257.79"
        width="23.18"
        height="2.95"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="125.63"
        y="322.9"
        width="23.18"
        height="2.95"
        transform="translate(-143.82 112.08) rotate(-30)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="173.3"
        y="370.57"
        width="23.18"
        height="2.96"
        transform="translate(-229.77 346.38) rotate(-60.03)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="248.52"
        y="377.9"
        width="2.95"
        height="23.18"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="313.63"
        y="360.46"
        width="2.96"
        height="23.18"
        transform="translate(-143.8 207.39) rotate(-30)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="361.3"
        y="312.79"
        width="2.95"
        height="23.18"
        transform="translate(-99.54 476.34) rotate(-60)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="368.63"
        y="257.79"
        width="23.18"
        height="2.95"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="351.19"
        y="192.68"
        width="23.18"
        height="2.95"
        transform="translate(-48.48 207.43) rotate(-30)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="303.52"
        y="145.01"
        width="23.18"
        height="2.96"
        transform="translate(30.81 346.31) rotate(-60.03)"
        style="fill:#c7c7c7"
      ></rect>
      <polygon
        points="390.66 261.24 242.35 265.38 242.53 250.88 390.7 257.3 390.66 261.24"
        style="fill:#2C70B7"
      ></polygon>
      <polygon
        points="251.02 154.98 257.44 267.84 242.93 267.65 247.09 154.93 251.02 154.98"
        style="fill:#263238"
      ></polygon>
      <circle cx="250" cy="259.27" r="4.95" style="fill:#2C70B7"></circle>
    </g>
    <g id="freepik--Character--inject-7">
      <path
        d="M386.53,259.18c-.55-1.66-30-40.55-32-41.29-.23-.1-13.38,9.26-13.38,9.26-.55.72-25.55-4.56-25.55-4.56l-.25,30.16,45.55-1s6.15,3.62,11.78,6.57h0a67.47,67.47,0,0,0,7.4,3.59C382.39,262.53,387.09,260.83,386.53,259.18Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M380.11,261.94a64.69,64.69,0,0,1-7.4-3.59h0c-5.63-3-11.78-6.57-11.78-6.57l-10.14.22L334.9,226.39c3.49.62,6.08,1,6.26.76,0,0,13.15-9.37,13.38-9.26,2,.74,31.44,39.62,32,41.29S382.39,262.53,380.11,261.94Z"
        style="fill:#fff"
      ></path>
      <path
        d="M386.8,259.23c-.58-1.7-30.14-40.56-32.21-41.33-.78-.3-7.21,3.68-13.43,9.25l19.08,25s17.61,9.33,20,9.93S387.38,260.93,386.8,259.23Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M384.82,259.85c-5.12-6.39-25.15-32.65-29.72-39.36,0-.06,0-.08,0,0,5.2,6.22,25,32.65,29.78,39.31C385,259.91,384.93,260,384.82,259.85Z"
        style="fill:#263238"
      ></path>
      <path
        d="M376.91,260.67a6.54,6.54,0,0,1-1.37-5.1,6.33,6.33,0,0,1,2.37-4.11s.09,0,.06.08a7.59,7.59,0,0,0-1,9.07A.05.05,0,1,1,376.91,260.67Z"
        style="fill:#263238"
      ></path>
      <path
        d="M362.45,253.73c-2-2.58-3.4-6.31-2.5-9.55,0-.13.22-.07.23,0a45.19,45.19,0,0,0,2.63,9.32A.21.21,0,0,1,362.45,253.73Z"
        style="fill:#263238"
      ></path>
      <path
        d="M364.77,255.14c-2-2.58-3.4-6.3-2.5-9.54,0-.13.21-.08.23,0a45.71,45.71,0,0,0,2.62,9.31A.2.2,0,0,1,364.77,255.14Z"
        style="fill:#263238"
      ></path>
      <path
        d="M367.08,256.56c-2-2.58-3.4-6.31-2.5-9.55,0-.12.22-.07.24,0a44.46,44.46,0,0,0,2.62,9.31A.21.21,0,0,1,367.08,256.56Z"
        style="fill:#263238"
      ></path>
      <path
        d="M369.4,258c-2-2.58-3.4-6.3-2.5-9.54,0-.13.21-.08.23,0a45.71,45.71,0,0,0,2.62,9.31A.2.2,0,0,1,369.4,258Z"
        style="fill:#263238"
      ></path>
      <path
        d="M350.18,226.86c-2.22-2.94,2.33-6.39,4.56-3.45S352.4,229.79,350.18,226.86Z"
        style="fill:#263238"
      ></path>
      <path
        d="M361.3,258.72c.75-2.79.26-5.8.13-8.63a.4.4,0,0,0-.57-.31.08.08,0,0,0-.13,0,17.26,17.26,0,0,0-4.87,7.44c-.52,1.68-.32,4.16,1.78,4.65S360.87,260.35,361.3,258.72Zm-2.07,1.76c-3,1.9-2.8-2.31-2.37-3.54a19.62,19.62,0,0,1,1-2.29,51.24,51.24,0,0,1,2.74-4.4c0,1.39.08,2.78.11,4.17C360.78,256.08,360.91,259.44,359.23,260.48Z"
        style="fill:#263238"
      ></path>
      <path
        d="M352,241.76c-1.55,1.5-.44,3.72.87,4.89a17.19,17.19,0,0,0,8,3.87.09.09,0,0,0,.1-.09.41.41,0,0,0,.33-.56c-1.35-2.49-2.49-5.33-4.56-7.33C355.55,241.37,353.48,240.34,352,241.76Zm6.49,4.75c.69,1.21,1.32,2.45,2.06,3.63a51.67,51.67,0,0,1-4.63-2.36,19.4,19.4,0,0,1-2.06-1.43c-1-.82-3.37-4.32.2-4.26C356.06,242.13,357.68,245.07,358.51,246.51Z"
        style="fill:#263238"
      ></path>
      <path
        d="M314.23,213.34H293.79s-21.39-10.28-38.61-6.14c-19.75,4.75-22.28,29.55-7.52,38.32,18.71,11.11,101.93,9,101.93,9L331.6,224s-27.68-5.82-52.78-5l35.41,4.83Z"
        style="fill:#455a64"
      ></path>
      <path
        d="M332.79,226a.9.9,0,0,1,0-.16l0-.13c0-.09-.05-.19-.07-.29s-.14-.4-.21-.6-.17-.39-.26-.58a3.71,3.71,0,0,0-.33-.54s0,0-.05,0l0,0,0,0,0,0c-3.05-.57-23.73-3.53-26.8-3.88s-6.21-.64-9.32-.9a184.49,184.49,0,0,0-18.66-.67l-1.75,0c-.12,0-.26-.06-.38-.09l-.9-.21c-.56-.1-1.13-.19-1.69-.27-1.18-.18-2.36-.31-3.54-.53-.07,0-.09.1,0,.11,1.18.27,2.33.61,3.51.86l1,.22c-2.28.12-4.56.3-6.84.5-.07,0-.07.12,0,.12,3.1-.19,6.23-.21,9.33-.16s6.16.12,9.24.3c6.23.36,12.45.91,18.65,1.56,3.48.37,24.57,3.44,28.06,3.59h.05a2.34,2.34,0,0,0,.09.24l.3.57c.1.18.2.35.31.52l.17.26.09.12s.08.09.09.13S332.84,226,332.79,226Z"
        style="fill:#263238"
      ></path>
      <path
        d="M343.1,252.63C342,250.85,341,249,340,247.11s-2-3.69-3.07-5.53c-2.05-3.67-9.39-16-10.12-16.89,0-.05-.14,0-.12.07.35,1,4.94,9.14,6,11,2.11,3.65,4.33,7.22,6.52,10.83.62,1,1.27,2,1.9,3.06s1.31,2,1.89,3.08C343,252.75,343.14,252.69,343.1,252.63Z"
        style="fill:#263238"
      ></path>
      <path
        d="M326.61,227.77c-1.83-.45-3.71-.73-5.57-1.08l-5.58-1.05q-5.58-1-11.18-2c-7.45-1.26-14.93-2.3-22.45-3-4.24-.4-8.49-.67-12.75-1-.09,0-.08.13,0,.14,7.57.34,15.13,1.36,22.63,2.44s14.83,2.24,22.23,3.49l6.26,1.07c2.12.37,4.24.82,6.37,1.09C326.66,227.9,326.7,227.78,326.61,227.77Z"
        style="fill:#263238"
      ></path>
      <path
        d="M347.76,358.4c-1.79-.18-46.37-20.22-47.59-22.06-.46-.69,2.08-7.35,5.37-15.32.72-1.72,1.46-3.49,2.23-5.28,5-11.66,10.51-23.92,10.51-23.92l29.86,13.32-11.33,23.55-2.48,5.17s13.63,15.3,14.75,17.46S349.56,358.58,347.76,358.4Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M347.76,358.4c-1.79-.18-46.37-20.22-47.59-22.06-.56-.84,3.3-10.5,7.6-20.6l29,12.95-2.48,5.17s13.63,15.3,14.75,17.46S349.56,358.58,347.76,358.4Z"
        style="fill:#fff"
      ></path>
      <path
        d="M347.76,358.4c-1.79-.18-46.37-20.22-47.59-22.06-.46-.69,2.08-7.35,5.37-15.32l28.79,12.84s13.63,15.3,14.75,17.46S349.56,358.58,347.76,358.4Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M347.93,356.33c-7.39-3.54-37.54-17.13-45.11-20.07-.07,0-.08,0,0,0,7.25,3.67,37.51,17,45.08,20.15C348,356.52,348.08,356.4,347.93,356.33Z"
        style="fill:#263238"
      ></path>
      <path
        d="M346.93,348.43a6.58,6.58,0,0,0-5.29-.18,6.32,6.32,0,0,0-3.46,3.24s.06.08.09,0a7.59,7.59,0,0,1,8.62-3A.05.05,0,0,0,346.93,348.43Z"
        style="fill:#263238"
      ></path>
      <path
        d="M336.89,335.9c-3-1.38-6.92-1.88-9.87-.27-.12.06,0,.22.08.21a45.49,45.49,0,0,1,9.68.46A.21.21,0,0,0,336.89,335.9Z"
        style="fill:#263238"
      ></path>
      <path
        d="M338.79,337.84c-3-1.38-6.91-1.89-9.87-.28-.11.07,0,.23.09.22a45.39,45.39,0,0,1,9.67.45A.2.2,0,0,0,338.79,337.84Z"
        style="fill:#263238"
      ></path>
      <path
        d="M340.7,339.78c-3-1.39-6.92-1.89-9.87-.28-.12.06,0,.23.08.22a45.36,45.36,0,0,1,9.67.45A.21.21,0,0,0,340.7,339.78Z"
        style="fill:#263238"
      ></path>
      <path
        d="M342.6,341.72c-3-1.39-6.91-1.89-9.87-.28-.11.06,0,.22.09.22a45.39,45.39,0,0,1,9.67.45A.2.2,0,0,0,342.6,341.72Z"
        style="fill:#263238"
      ></path>
      <path
        d="M307.91,330c-3.36-1.5-5.7,3.72-2.33,5.23S311.28,331.51,307.91,330Z"
        style="fill:#263238"
      ></path>
      <path
        d="M343.71,329.38c-.95-1.94-3.41-1.57-4.93-.69a17.17,17.17,0,0,0-6.15,6.43.08.08,0,0,0,.05.13.4.4,0,0,0,.43.48c2.79-.51,5.84-.72,8.39-2.08C343,332.86,344.61,331.21,343.71,329.38Zm-6.53,4.7c-1.36.29-2.74.51-4.09.85,1.2-1.25,2.35-2.55,3.67-3.68a19.6,19.6,0,0,1,2-1.53c1.1-.69,5.16-1.87,4,1.52C342.11,333.1,338.81,333.74,337.18,334.08Z"
        style="fill:#263238"
      ></path>
      <path
        d="M324.7,332.89c2.42,1.57,5.44,2,8.18,2.79.28.08.48-.2.47-.45a.08.08,0,0,0,.06-.12,17.14,17.14,0,0,0-5.58-6.93c-1.44-1-3.86-1.59-5,.26S323.28,332,324.7,332.89Zm-1.05-2.52c-.87-3.47,3.08-1.95,4.11-1.16a19.83,19.83,0,0,1,1.86,1.69,50.73,50.73,0,0,1,3.35,4c-1.32-.45-2.67-.79-4-1.19C327.37,333.21,324.13,332.29,323.65,330.37Z"
        style="fill:#263238"
      ></path>
      <path
        d="M308.45,313,342,328.18s40-76.72,41-100.21c.89-20-13-27.7-58-14.77l-11,.14v7.6c4.83.64,17.74,2.67,17.74,2.67,9.39,3.54,12.41,5,12.26,5.31C320.62,276.2,308.45,313,308.45,313Z"
        style="fill:#455a64"
      ></path>
      <path
        d="M349.53,220.48c-1.35,1.81-2.61,3.69-3.81,5.61a80.58,80.58,0,0,0-22.88-6q-3.31-.41-6.66-.59c-.09,0-.09.13,0,.14A100.38,100.38,0,0,1,339.47,224c2.09.64,4.14,1.39,6.2,2.13-1.44,2.31-2.8,4.67-4.1,7.05A140.2,140.2,0,0,0,335,246.93c-1.08,2.59-2.13,5.2-3.06,7.85,0,.08.1.13.13.05q6.17-13.72,13.44-26.86c1.37-2.47,2.8-4.91,4.14-7.4C349.69,220.5,349.58,220.42,349.53,220.48Z"
        style="fill:#263238"
      ></path>
      <path
        d="M342.77,320.07c-2-.77-3.86-1.72-5.78-2.58l-5.77-2.59c-3.83-1.72-17.11-7.22-18.21-7.48-.07,0-.11.09-.05.13.85.55,9.42,4.36,11.35,5.19,3.88,1.66,7.79,3.2,11.7,4.78,1.12.45,2.24.87,3.36,1.32s2.26.84,3.35,1.33C342.79,320.2,342.83,320.09,342.77,320.07Z"
        style="fill:#263238"
      ></path>
      <path
        d="M349.37,224c-2.65,5-4.91,10.31-7.21,15.51s-4.52,10.39-6.69,15.62q-6.47,15.64-12,31.64c-2.11,6-4.08,12.1-6,18.19,0,.08.11.12.14,0,3.56-10.77,7.41-21.44,11.44-32s8.28-21.06,12.79-31.43q1.9-4.36,3.86-8.71c1.31-2.9,2.67-5.78,3.9-8.71C349.6,223.93,349.43,223.83,349.37,224Z"
        style="fill:#263238"
      ></path>
      <path
        d="M294,215.78c.76.75,47.45.3,47.68,0,.61-.82-6.38-30.24-11.63-41.4-6.72-14.3-10.27-15.49-12.4-16.29a16.52,16.52,0,0,0-8.73-.07c-1.32.59-6.9,7.28-8.47,12.59C297.3,181.27,293.33,215.12,294,215.78Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M325.5,161.77c20.61,14.46,38.7,34.88,37.24,41.58-1.54,7.08-15.19,15.4-27.42,17.4-2.5.41-10.89-17.78-8.34-18.72,2-.72,11-3.61,12.08-4.9.73-.9-14.08-20.36-19-30.62C314.85,155.78,320,157.9,325.5,161.77Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M332.15,201.31s-7.65,1-12.63,1.92c-2.77.51-7.45,1.79-9.32,3.1-2.79,1.95-13.24,11.88-10.88,14.47,2.13,2.34,5.1-1.57,5.1-1.57s-3.65,4-.82,5.63,6.23-3.78,6.23-3.78-4.17,3.94-1,5.44c2.76,1.3,7.34-4.58,7.34-4.58s-4.83,3.66-2.13,5.27c3,1.78,11-6.17,11-6.17a36.22,36.22,0,0,0,15.21-1.51C341.07,219.26,332.15,201.31,332.15,201.31Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M308.71,222.4l.87-1.24a25.5,25.5,0,0,1,1.76-2.37c.63-.72,1.29-1.41,2-2.09s1.52-1.35,2.22-2.08a.06.06,0,1,1,.08.08,28.19,28.19,0,0,0-2,2.25l-1.87,2.27c-.61.75-1.26,1.44-1.89,2.17-.31.36-.61.74-.9,1.11a8.82,8.82,0,0,1-.87,1.05,0,0,0,0,1-.07-.05A6.93,6.93,0,0,1,308.71,222.4Z"
        style="fill:#263238"
      ></path>
      <path
        d="M303.68,220.07a38.33,38.33,0,0,1,3.17-4.46,27.36,27.36,0,0,1,3.93-3.83.06.06,0,0,1,.08.08c-1.18,1.41-2.38,2.8-3.57,4.18-.59.68-3.15,3.85-3.46,4.15C303.75,220.26,303.64,220.15,303.68,220.07Z"
        style="fill:#263238"
      ></path>
      <path
        d="M313.39,224.72a39,39,0,0,1,3.06-4.14,34.24,34.24,0,0,1,4-3.4.06.06,0,0,1,.08.08c-1.25,1.23-2.52,2.43-3.7,3.73-.58.63-2.74,3.27-3.35,3.82C313.45,224.86,313.36,224.79,313.39,224.72Z"
        style="fill:#263238"
      ></path>
      <path
        d="M348.48,179.68l-15,10.43s-11.94-17.23-15.16-25.47.22-8.37,8.46-2.59S348.48,179.68,348.48,179.68Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M344.93,177.6a125.53,125.53,0,0,1-12.48,9c-.05,0-.11-.05-.05-.09,1.14-.74,7.24-5.54,12.47-9C344.93,177.46,345,177.55,344.93,177.6Z"
        style="fill:#263238"
      ></path>
      <path
        d="M334.44,189.4c-.1,0-.77.43-.91.51-1.8-2.88-3.73-5.8-5.56-8.67-.89-1.4-1.79-2.8-2.68-4.21s-1.78-3-2.79-4.41a0,0,0,0,0-.07,0,46.45,46.45,0,0,0,2.23,4.1,7.37,7.37,0,0,0-.5-.61c-.39-.44-.77-.88-1.13-1.34-.06-.08-.18,0-.12.07.34.45.65.91.95,1.38s.64.92,1,1.37.67.84,1,1.25l.13.15c.49.84,1,1.68,1.49,2.51,1.8,2.9,5.87,8.73,5.92,8.71a8.41,8.41,0,0,0,1.08-.77S334.49,189.39,334.44,189.4Z"
        style="fill:#263238"
      ></path>
      <path
        d="M300.28,162c-16.06,9-31,19.84-33.7,27.1-1.66,4.57.84,12.67,2.82,17.53,1,2.36,23.25-7.69,21.31-9.61-4.8-4.76-5.61-6.71-5.14-7.72.29-.64,17.66-16.74,22.44-23.89C314.68,155.44,307.3,158.07,300.28,162Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M300,218.9c-2.1,1.27-4.78-4.16-4.78-4.16a4.51,4.51,0,0,1-1.17,2.84c-1.31,1.31-3.95-.17-3.95-.17a5.6,5.6,0,0,1-1.71,2.8c-1.39,1.13-4.26,0-4.26,0a4.93,4.93,0,0,1-3.06,1.51c-3.13.2-5.92-3.69-7.72-6.15s-4.6-11.1-5.3-12.7l15.66-11.68s11.2,8.71,12.9,11.9C298,205.8,303.16,217,300,218.9Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M295.21,214.66a40.7,40.7,0,0,0-4-9.13c0-.06-.13,0-.1.06,1.61,2.86,2.5,6.21,4,9.13A.08.08,0,0,0,295.21,214.66Z"
        style="fill:#263238"
      ></path>
      <path
        d="M290.22,217.21a8.37,8.37,0,0,0-1.05-2c-.42-.69-.86-1.36-1.3-2q-1.33-2-2.77-4c0-.06-.14,0-.1,0,.89,1.34,1.75,2.69,2.58,4.07.41.69.82,1.38,1.22,2.07a11,11,0,0,0,1.23,1.92A.11.11,0,0,0,290.22,217.21Z"
        style="fill:#263238"
      ></path>
      <path
        d="M284.05,220.17a6,6,0,0,0-1.05-1.76l-1.24-1.82c-.82-1.21-1.64-2.43-2.42-3.67,0-.07-.14,0-.1.05.78,1.27,1.55,2.55,2.35,3.81.39.62.78,1.24,1.18,1.85a5.72,5.72,0,0,0,1.22,1.58A0,0,0,0,0,284.05,220.17Z"
        style="fill:#263238"
      ></path>
      <path
        d="M277.1,175.5l12.34,11.33S304.71,172.4,309,164.66s.91-8.32-8-3.71S277.1,175.5,277.1,175.5Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M277.1,175.5l12.34,11.33S304.71,172.4,309,164.66s.91-8.32-8-3.71S277.1,175.5,277.1,175.5Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M291.83,183.69a117.14,117.14,0,0,1-10.89-10.17c-.05,0,0-.11.07-.06.92.94,6.62,5.84,10.9,10.15C292,183.66,291.88,183.73,291.83,183.69Z"
        style="fill:#263238"
      ></path>
      <path
        d="M301.89,167.75c-.56,1.3-1.12,2.6-1.58,3.94a2.44,2.44,0,0,0,0-.27,18.15,18.15,0,0,1,.29-2.42c0-.09-.12-.12-.13,0-.16.8-.3,1.61-.4,2.43-.05.39-.07.78-.09,1.17,0,0,0,.09,0,.14l0,0c-.52,1.78-.83,3.59-1.27,5.38,0,.09.12.12.14,0,.43-1.76,1.08-3.47,1.64-5.19s1-3.47,1.53-5.19C302,167.73,301.92,167.69,301.89,167.75Z"
        style="fill:#263238"
      ></path>
      <path
        d="M310.26,166.08c2.65.64,7.22-3.4,9-6.67.12-.23-.21-2.6-.48-5.51-.16-1.76-.29-3.73-.29-5.53,0-.37-11.32,2.7-11.32,2.7a28.92,28.92,0,0,1,1.06,6.93,3.5,3.5,0,0,1-.08.74.74.74,0,0,1,0,.12C307.93,160.27,307.7,165.46,310.26,166.08Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M317.83,148.41c-.54,3.05-2.47,10.41-8.51,10.52a6,6,0,0,1-1.15-.07c0-.05,0-.08,0-.12a4.4,4.4,0,0,0,.09-.74,28.69,28.69,0,0,0-1.07-6.93S315.37,148.85,317.83,148.41Z"
        style="fill:#263238"
      ></path>
      <path
        d="M317.92,133.42c2,3.69,2.19,15.47-.1,18.56-3.32,4.49-9.89,6.17-14,1.92s-4-19.47-1.3-22.4C306.46,127.18,315,128,317.92,133.42Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M318.08,151.81h0"
        style="fill:none;stroke:#f5a79e;stroke-linecap:round;stroke-linejoin:round;stroke-width:0px"
      ></path>
      <path
        d="M309,143.94s.06,0,.06.07c0,.8.12,1.71.84,2,0,0,0,0,0,0C309,145.91,308.85,144.7,309,143.94Z"
        style="fill:#263238"
      ></path>
      <path
        d="M309.67,143.1c1.27-.12,1.43,2.43.25,2.55S308.6,143.21,309.67,143.1Z"
        style="fill:#263238"
      ></path>
      <path
        d="M304.55,144.24s-.06,0-.06.07c.08.79,0,1.71-.67,2,0,0,0,0,0,0C304.69,146.19,304.74,145,304.55,144.24Z"
        style="fill:#263238"
      ></path>
      <path
        d="M303.79,143.45c-1.28,0-1.22,2.55,0,2.56S304.86,143.47,303.79,143.45Z"
        style="fill:#263238"
      ></path>
      <path
        d="M310.73,141c-.36,0-.7-.07-1.05-.11a1.69,1.69,0,0,1-1.05-.31.56.56,0,0,1-.07-.66,1.35,1.35,0,0,1,1.29-.45,2,2,0,0,1,1.3.56A.58.58,0,0,1,310.73,141Z"
        style="fill:#263238"
      ></path>
      <path
        d="M302.5,141.66a8.36,8.36,0,0,0,1-.33,1.66,1.66,0,0,0,1-.52.54.54,0,0,0-.07-.66A1.33,1.33,0,0,0,303,140a2,2,0,0,0-1.16.83A.58.58,0,0,0,302.5,141.66Z"
        style="fill:#263238"
      ></path>
      <path
        d="M310.75,151.22c-.18.2-.35.47-.64.51a2.14,2.14,0,0,1-.86-.15s-.05,0,0,0a1.06,1.06,0,0,0,1,.37.84.84,0,0,0,.58-.74S310.78,151.19,310.75,151.22Z"
        style="fill:#263238"
      ></path>
      <path
        d="M309.77,148.9a2.69,2.69,0,0,1-1.72,1.31,3.9,3.9,0,0,1-1,.11h-.19l-.17,0a.2.2,0,0,1-.17-.17h0V150h0V150c-.06-.61-.05-1.54-.05-1.54-.22.12-1.32.7-1.33.38a41.28,41.28,0,0,1,.55-8.22.08.08,0,0,1,.15,0c.1,2.55-.24,5.09-.18,7.65a5.09,5.09,0,0,1,1.25-.47c.09,0,0,1.8,0,2.07v0a3.78,3.78,0,0,0,2.74-1C309.75,148.79,309.82,148.84,309.77,148.9Z"
        style="fill:#263238"
      ></path>
      <path
        d="M307.42,150a3.25,3.25,0,0,0,1.34.92,1.47,1.47,0,0,0,.88,0c.62-.21.6-.79.46-1.28a3.51,3.51,0,0,0-.33-.74A4.14,4.14,0,0,1,307.42,150Z"
        style="fill:#263238"
      ></path>
      <path
        d="M308.76,150.9a1.47,1.47,0,0,0,.88,0c.62-.21.6-.79.46-1.28A1.5,1.5,0,0,0,308.76,150.9Z"
        style="fill:#ff98b9"
      ></path>
      <path
        d="M301.69,136.77c4.17,2.18,9-2.44,9-2.44a4.22,4.22,0,0,0,4.57,2.15s1.53,6.44,3.24,6.22c2.62-.33,2.38-9.32,1.35-11a4.74,4.74,0,0,0-3.31-1.84,4.36,4.36,0,0,0-2.09-2.38c-2-1.16-7.91,1.42-7.91,1.42a5.78,5.78,0,0,0-1.84-2,1.64,1.64,0,0,0-2.31.49,3.72,3.72,0,0,1,.82,1.54c.54,1.87-1,2.05-1.21.32a2.7,2.7,0,0,1,.39-1.86c-.9-1-2.2-1.26-2.89-.56C298.21,128.17,298.23,135,301.69,136.77Z"
        style="fill:#263238"
      ></path>
      <path
        d="M303.21,147.75c-1.19.08-2.26-1.31-2.38-3.1s.73-3.33,1.92-3.41,2.25,1.31,2.38,3.1S304.4,147.66,303.21,147.75Zm-.43-6.07c-.95.06-1.63,1.38-1.52,2.94s1,2.76,1.92,2.69,1.63-1.38,1.51-2.94S303.72,141.61,302.78,141.68Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M310.5,147.23a3.27,3.27,0,1,1,2.81-3.47A3.17,3.17,0,0,1,310.5,147.23Zm-.43-6.08a2.84,2.84,0,1,0,2.81,2.64A2.74,2.74,0,0,0,310.07,141.15Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M307.36,143.89c-1.67-.46-2.37.13-2.37.13l-.3-.32s.86-.76,2.78-.23Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M313.07,143.49l-.11-.43c.28-.07,6.83-1.77,7.55-1.86a7.83,7.83,0,0,1,2.81.87l-.18.39a8.4,8.4,0,0,0-2.54-.83h0C320,141.7,315.42,142.88,313.07,143.49Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M317.35,143.16s1.91-4.15,3.75-3.53.86,6.31-1,7.4a2,2,0,0,1-2.87-.6Z"
        style="fill:#dd6a57"
      ></path>
      <path
        d="M320.78,141.26a0,0,0,0,1,0,.05,5.1,5.1,0,0,0-2,3.62,1.12,1.12,0,0,1,1.6-.59s0,.08,0,.08a1.24,1.24,0,0,0-1.27.67,5.91,5.91,0,0,0-.46,1.21c0,.13-.27.11-.25,0v0C318,144.47,318.93,141.77,320.78,141.26Z"
        style="fill:#263238"
      ></path>
      <path
        d="M320.68,160.2a53,53,0,0,1-3.8,4.51,8.69,8.69,0,0,1-4.74,2.74c-1.78.24-3.58,0-4.33-2.22a13,13,0,0,1-.37-5.74c0-.1-.13-.12-.14,0-.29,2.89-.53,7.34,2.12,8.22,3,1,5.75-.63,7.71-2.73a27.31,27.31,0,0,0,3.61-4.72S320.71,160.17,320.68,160.2Z"
        style="fill:#263238"
      ></path>
      <rect
        x="284.89"
        y="225.44"
        width="53.65"
        height="2.41"
        style="fill:#263238"
      ></rect>
      <polygon
        points="324.77 227.84 272.48 227.84 268.13 192.33 320.41 192.33 324.77 227.84"
        style="fill:#263238"
      ></polygon>
      <path
        d="M299.63,210.09a3.11,3.11,0,0,1-3.13,3.18,3.26,3.26,0,0,1-3.24-3.18,3.12,3.12,0,0,1,3.13-3.19A3.26,3.26,0,0,1,299.63,210.09Z"
        style="fill:#fff"
      ></path>
    </g>
    <g id="freepik--Calendar--inject-7">
      <polygon
        points="290.23 450.19 97.34 450.19 63.63 310.22 256.52 310.22 290.23 450.19"
        style="fill:#a6a6a6"
      ></polygon>
      <polygon
        points="29.36 450.19 222.25 450.19 255.96 310.22 63.07 310.22 29.36 450.19"
        style="fill:#dbdbdb"
      ></polygon>
      <polygon
        points="227.99 336.52 223.69 354.4 223.43 355.5 218.98 374.07 218.72 375.17 214.27 393.72 214 394.82 209.54 413.38 209.28 414.49 204.92 432.67 63.31 432.67 67.67 414.49 67.93 413.38 72.39 394.82 72.66 393.72 77.11 375.17 77.38 374.07 81.83 355.5 82.09 354.4 86.39 336.52 227.99 336.52"
        style="fill:#fff"
      ></polygon>
      <polygon
        points="107.13 336.52 102.83 354.4 102.57 355.5 98.12 374.07 97.86 375.17 93.41 393.72 93.14 394.82 88.69 413.38 88.42 414.49 84.06 432.67 82.93 432.67 87.3 414.49 87.56 413.38 92.01 394.82 92.28 393.72 96.72 375.17 96.99 374.07 101.45 355.5 101.71 354.4 105.99 336.52 107.13 336.52"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="127.3 336.52 123 354.4 122.74 355.5 118.29 374.07 118.03 375.17 113.58 393.72 113.31 394.82 108.86 413.38 108.59 414.49 104.23 432.67 103.1 432.67 107.47 414.49 107.73 413.38 112.18 394.82 112.45 393.72 116.89 375.17 117.16 374.07 121.62 355.5 121.88 354.4 126.16 336.52 127.3 336.52"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="147.48 336.52 143.19 354.4 142.92 355.5 138.47 374.07 138.21 375.17 133.76 393.72 133.5 394.82 129.04 413.38 128.77 414.49 124.41 432.67 123.28 432.67 127.65 414.49 127.92 413.38 132.36 394.82 132.63 393.72 137.08 375.17 137.34 374.07 141.8 355.5 142.06 354.4 146.35 336.52 147.48 336.52"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="167.65 336.52 163.36 354.4 163.09 355.5 158.64 374.07 158.38 375.17 153.93 393.72 153.67 394.82 149.21 413.38 148.94 414.49 144.58 432.67 143.45 432.67 147.82 414.49 148.09 413.38 152.53 394.82 152.8 393.72 157.25 375.17 157.51 374.07 161.97 355.5 162.23 354.4 166.52 336.52 167.65 336.52"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="187.83 336.52 183.54 354.4 183.27 355.5 178.83 374.07 178.56 375.17 174.11 393.72 173.85 394.82 169.39 413.38 169.13 414.49 164.77 432.67 163.63 432.67 168 414.49 168.27 413.38 172.72 394.82 172.98 393.72 177.43 375.17 177.69 374.07 182.15 355.5 182.41 354.4 186.7 336.52 187.83 336.52"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="208 336.52 203.71 354.4 203.44 355.5 199 374.07 198.73 375.17 194.28 393.72 194.02 394.82 189.56 413.38 189.3 414.49 184.94 432.67 183.8 432.67 188.17 414.49 188.44 413.38 192.89 394.82 193.15 393.72 197.6 375.17 197.86 374.07 202.32 355.5 202.59 354.4 206.87 336.52 208 336.52"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="223.69 354.4 223.43 355.5 81.83 355.5 82.09 354.4 223.69 354.4"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="218.98 374.07 218.72 375.17 77.11 375.17 77.38 374.07 218.98 374.07"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="214.27 393.72 214 394.82 72.39 394.82 72.66 393.72 214.27 393.72"
        style="fill:#ebebeb"
      ></polygon>
      <polygon
        points="209.54 413.38 209.28 414.49 67.67 414.49 67.93 413.38 209.54 413.38"
        style="fill:#ebebeb"
      ></polygon>
      <rect
        x="103.54"
        y="374.46"
        width="2.73"
        height="19.62"
        transform="translate(-218.12 151.2) rotate(-38.92)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="93.22"
        y="383.04"
        width="23.08"
        height="2.73"
        transform="translate(-231.63 170.89) rotate(-42.35)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="148.31"
        y="355.33"
        width="2.73"
        height="19.62"
        transform="translate(-196.17 175.08) rotate(-38.92)"
        style="fill:#c7c7c7"
      ></rect>
      <rect
        x="137.98"
        y="363.92"
        width="23.08"
        height="2.73"
        transform="translate(-207.06 196.05) rotate(-42.35)"
        style="fill:#c7c7c7"
      ></rect>
      <polygon
        points="88.1 373.73 82.89 364.62 85.26 363.26 88.52 368.96 100.4 354.63 102.5 356.37 88.1 373.73"
        style="fill:#2C70B7"
      ></polygon>
      <polygon
        points="113.31 431.63 108.1 422.52 110.47 421.16 113.72 426.86 125.6 412.53 127.7 414.27 113.31 431.63"
        style="fill:#2C70B7"
      ></polygon>
      <path
        d="M185,376a32.15,32.15,0,0,0-6.92,5.12c-2,2-3.75,4.43-4,7.16a4.71,4.71,0,0,0,.92,3.63,6.64,6.64,0,0,0,3.41,1.89,18,18,0,0,0,8.28-.21,18.35,18.35,0,0,0,7.51-3.51,10.29,10.29,0,0,0,2.61-3.12,6.52,6.52,0,0,0,.81-3.8,4.85,4.85,0,0,0-2.09-3.2,10.59,10.59,0,0,0-3.81-1.65,17.76,17.76,0,0,0-8.51.09,17,17,0,0,1,8.66-.8,11.27,11.27,0,0,1,4.2,1.59,6,6,0,0,1,2.68,3.77,7.26,7.26,0,0,1-.82,4.58,11.58,11.58,0,0,1-2.87,3.56,20.35,20.35,0,0,1-17,4,7.83,7.83,0,0,1-4-2.35,4.86,4.86,0,0,1-1-2.21,7.72,7.72,0,0,1,0-2.35c.46-3.11,2.45-5.6,4.61-7.53A29.42,29.42,0,0,1,185,376Z"
        style="fill:#2C70B7"
      ></path>
      <polygon
        points="102.7 341.5 87.66 341.5 88.08 339.66 103.12 339.66 102.7 341.5"
        style="fill:#c7c7c7"
      ></polygon>
      <polygon
        points="95.78 344.64 86.94 344.64 87.36 342.81 96.2 342.81 95.78 344.64"
        style="fill:#c7c7c7"
      ></polygon>
      <polygon
        points="163.83 399.28 154.68 399.28 155.1 397.45 164.25 397.45 163.83 399.28"
        style="fill:#c7c7c7"
      ></polygon>
      <polygon
        points="162.38 405.69 153.23 405.69 153.65 403.86 162.81 403.86 162.38 405.69"
        style="fill:#c7c7c7"
      ></polygon>
      <polygon
        points="168.3 402.43 153.95 402.43 154.38 400.59 168.72 400.59 168.3 402.43"
        style="fill:#c7c7c7"
      ></polygon>
      <polygon
        points="187.53 385.15 178.38 385.15 178.8 383.31 187.96 383.31 187.53 385.15"
        style="fill:#c7c7c7"
      ></polygon>
      <polygon
        points="192 388.29 177.65 388.29 178.08 386.46 192.42 386.46 192 388.29"
        style="fill:#c7c7c7"
      ></polygon>
      <path
        d="M64.64,351.21l8.83-6.6a5.37,5.37,0,0,0,2-3,3.36,3.36,0,0,0-.43-2.68,3.12,3.12,0,0,0-2.67-1.32,5,5,0,0,0-3,1l-.92.69a.51.51,0,0,1-.76,0,.55.55,0,0,1,.2-.76l.92-.72a6.52,6.52,0,0,1,3.77-1.32A3.88,3.88,0,0,1,76,338.2a4.21,4.21,0,0,1,.55,3.42,6.83,6.83,0,0,1-2.55,3.8l-7.56,5.65h7.39a.43.43,0,0,1,.41.56.73.73,0,0,1-.66.54H64.79a.4.4,0,0,1-.36-.16A.62.62,0,0,1,64.64,351.21Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M60.27,371.18A12.61,12.61,0,0,1,63,365.71a6.4,6.4,0,0,1,4.46-2.35,3.65,3.65,0,0,1,3.36,2.35,9,9,0,0,1,.26,5.47,12.55,12.55,0,0,1-2.78,5.45A6.36,6.36,0,0,1,63.87,379a3.64,3.64,0,0,1-3.36-2.37A8.87,8.87,0,0,1,60.27,371.18Zm1.1,0a8,8,0,0,0,.19,4.85,2.83,2.83,0,0,0,2.57,1.88A5,5,0,0,0,67.55,376,11.21,11.21,0,0,0,70,371.18a8,8,0,0,0-.23-4.85,2.76,2.76,0,0,0-2.56-1.88,4.84,4.84,0,0,0-3.43,1.88A11.16,11.16,0,0,0,61.37,371.18Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M52.25,404.88l8.83-6.6a5.37,5.37,0,0,0,2-3,3.36,3.36,0,0,0-.43-2.68A3.13,3.13,0,0,0,60,391.29a5,5,0,0,0-3,1l-.92.69a.51.51,0,0,1-.76,0,.55.55,0,0,1,.2-.76l.92-.72a6.52,6.52,0,0,1,3.77-1.32,3.88,3.88,0,0,1,3.37,1.68,4.21,4.21,0,0,1,.55,3.42,6.83,6.83,0,0,1-2.55,3.8l-7.57,5.65h7.4a.43.43,0,0,1,.41.56.73.73,0,0,1-.66.54H52.4a.4.4,0,0,1-.36-.16A.62.62,0,0,1,52.25,404.88Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M47.88,424.85a12.61,12.61,0,0,1,2.76-5.47A6.4,6.4,0,0,1,55.1,417a3.65,3.65,0,0,1,3.36,2.35,9.08,9.08,0,0,1,.26,5.47,12.66,12.66,0,0,1-2.78,5.45,6.36,6.36,0,0,1-4.46,2.37,3.63,3.63,0,0,1-3.36-2.37A8.87,8.87,0,0,1,47.88,424.85Zm1.1,0a8,8,0,0,0,.19,4.85,2.85,2.85,0,0,0,2.57,1.88,5,5,0,0,0,3.42-1.88,11.09,11.09,0,0,0,2.46-4.85A7.88,7.88,0,0,0,57.4,420a2.76,2.76,0,0,0-2.56-1.88A4.84,4.84,0,0,0,51.41,420,11.16,11.16,0,0,0,49,424.85Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M230.46,332.73s-4.28,18.55-6.09,26.41S215.1,372,215.1,372H174.25s7.27-8.65,8.75-15.07l5.59-24.2Z"
        style="fill:#2C70B7"
      ></path>
      <path
        d="M194.45,346.26l-2.14,2.25a.24.24,0,0,1-.16.08h0a.13.13,0,0,1-.13-.08l-1.1-2.24-1,4.15a.23.23,0,0,1-.21.17.13.13,0,0,1-.14-.17l1.08-4.68a.21.21,0,0,1,.1-.14h0a.16.16,0,0,1,.23,0l1.23,2.49,2.36-2.49a.2.2,0,0,1,.26,0,.13.13,0,0,1,0,.06.27.27,0,0,1,0,.09l-1.08,4.68a.23.23,0,0,1-.21.17.13.13,0,0,1-.13-.17Z"
      ></path>
      <path
        d="M196.41,345.71a.24.24,0,0,1,.22-.17h2.6a.13.13,0,0,1,.13.17.23.23,0,0,1-.22.18h-2.42l-.46,2h2.12a.14.14,0,0,1,.13.18.23.23,0,0,1-.21.18h-2.12l-.46,2h2.42a.13.13,0,0,1,.13.18.22.22,0,0,1-.21.17h-2.62a.13.13,0,0,1-.12-.17Z"
      ></path>
      <path
        d="M200.7,345.71a.23.23,0,0,1,.21-.17h2.6a.14.14,0,0,1,.14.17.24.24,0,0,1-.22.18H201l-.46,2h2.12a.14.14,0,0,1,.13.18.23.23,0,0,1-.22.18h-2.11l-.46,2h2.42c.1,0,.15.08.13.18a.23.23,0,0,1-.22.17h-2.61a.13.13,0,0,1-.12-.17Z"
      ></path>
      <path
        d="M206.25,345.89h-1.52a.14.14,0,0,1-.14-.18.25.25,0,0,1,.22-.17h3.39a.14.14,0,0,1,.14.17.24.24,0,0,1-.22.18H206.6l-1,4.53a.23.23,0,0,1-.21.17.14.14,0,0,1-.14-.17Z"
      ></path>
      <path
        d="M209.72,345.71a.23.23,0,0,1,.21-.17.14.14,0,0,1,.14.17L209,350.42a.25.25,0,0,1-.23.17.13.13,0,0,1-.13-.17Z"
      ></path>
      <path
        d="M212.11,346.28l-1,4.14a.23.23,0,0,1-.21.17.13.13,0,0,1-.13-.17l1.07-4.64a.2.2,0,0,1,.11-.19c.09,0,.2,0,.23,0l2.09,4.25.95-4.12a.23.23,0,0,1,.21-.17.14.14,0,0,1,.14.17l-1.08,4.66a.24.24,0,0,1-.22.17.14.14,0,0,1-.12-.06l0,0Z"
      ></path>
      <path
        d="M218.84,348.32a.13.13,0,0,1-.14-.17.23.23,0,0,1,.23-.18h1.58a.13.13,0,0,1,.11.18l-.4,1.73v0a.26.26,0,0,1-.1.13,3.21,3.21,0,0,1-1.76.55,2,2,0,0,1-2-2.57,3.44,3.44,0,0,1,3.22-2.55,2.09,2.09,0,0,1,1.5.57.17.17,0,0,1,0,.24.2.2,0,0,1-.26,0,1.81,1.81,0,0,0-1.3-.49,3,3,0,0,0-2.78,2.2,1.73,1.73,0,0,0,1.76,2.22,2.81,2.81,0,0,0,1.44-.43l.34-1.49Z"
      ></path>
      <path
        d="M187.68,354.72l-.81.42a.19.19,0,0,1-.1,0,.13.13,0,0,1-.13-.08.19.19,0,0,1,.12-.24l1.11-.6a.17.17,0,0,1,.23.07.2.2,0,0,1,0,.13L187,359.09a.24.24,0,0,1-.22.18.14.14,0,0,1-.13-.18Z"
      ></path>
      <path
        d="M192.38,354.53l-1.62,1.34a1.3,1.3,0,0,1,.76.47,1.45,1.45,0,0,1,.22,1.21,2.33,2.33,0,0,1-2.12,1.72,1.34,1.34,0,0,1-1.09-.51c-.06-.06,0-.18.06-.25a.17.17,0,0,1,.25,0,1.08,1.08,0,0,0,.87.39,1.73,1.73,0,0,0,1-.39,1.76,1.76,0,0,0,.62-1,1.09,1.09,0,0,0-.18-.95,1,1,0,0,0-.86-.4.16.16,0,0,1-.13-.07h0a.2.2,0,0,1,.06-.26l1.56-1.3h-1.94a.14.14,0,0,1-.14-.18.25.25,0,0,1,.23-.18h2.36a.14.14,0,0,1,.14.18.2.2,0,0,1,0,.08Z"
      ></path>
      <path
        d="M194.92,355.9a.25.25,0,0,1-.21.18h-.46l-.59,2.57a.21.21,0,0,0,.2.26.15.15,0,0,1,.14.18.27.27,0,0,1-.22.18.47.47,0,0,1-.48-.62l.59-2.57h-.44c-.17,0-.15-.09-.13-.18a.18.18,0,0,1,.21-.17H194l.31-1.32a.25.25,0,0,1,.21-.17.15.15,0,0,1,.15.17l-.31,1.32h.46A.14.14,0,0,1,194.92,355.9Z"
      ></path>
      <path
        d="M198.75,357.12a.81.81,0,0,0-.88-1,1.39,1.39,0,0,0-1.36,1l-.46,2v0l0,0s0,0,0,0a.18.18,0,0,1-.13.09h0a.13.13,0,0,1-.12-.06.14.14,0,0,1,0-.06.15.15,0,0,1,0-.06l.45-2,0-.06.61-2.68a.25.25,0,0,1,.22-.17.14.14,0,0,1,.14.17l-.43,1.87a1.85,1.85,0,0,1,1.24-.52,1.09,1.09,0,0,1,1.16,1.39l-.46,2a.23.23,0,0,1-.22.18.14.14,0,0,1-.13-.18Z"
      ></path>
      <path
        d="M200.47,356.75a.17.17,0,0,1,.17-.13h1.54a.11.11,0,0,1,.11.13.19.19,0,0,1-.17.15h-1.54A.11.11,0,0,1,200.47,356.75Z"
      ></path>
      <path
        d="M204.42,354.72l-.81.42a.19.19,0,0,1-.1,0,.13.13,0,0,1-.13-.08.19.19,0,0,1,.12-.24l1.11-.6a.17.17,0,0,1,.23.07.29.29,0,0,1,0,.13l-1.07,4.64a.24.24,0,0,1-.22.18.14.14,0,0,1-.13-.18Z"
      ></path>
      <path
        d="M205.62,356.74a4.17,4.17,0,0,1,.89-1.77,2.08,2.08,0,0,1,1.44-.76A1.17,1.17,0,0,1,209,355a3,3,0,0,1,.09,1.77,4.09,4.09,0,0,1-.9,1.76,2.06,2.06,0,0,1-1.44.77,1.16,1.16,0,0,1-1.09-.77A2.92,2.92,0,0,1,205.62,356.74Zm.36,0a2.54,2.54,0,0,0,.06,1.57.91.91,0,0,0,.83.6,1.63,1.63,0,0,0,1.11-.6,3.59,3.59,0,0,0,.79-1.57,2.53,2.53,0,0,0-.07-1.57.89.89,0,0,0-.83-.6,1.56,1.56,0,0,0-1.11.6A3.57,3.57,0,0,0,206,356.74Z"
      ></path>
      <path
        d="M213.52,358h-2.3l-.73,1.19a.24.24,0,0,1-.19.12h-.06a.15.15,0,0,1-.05-.23l2.84-4.69a.26.26,0,0,1,.2-.11c.07,0,.14,0,.14.11l.68,4.69a.25.25,0,0,1-.15.23h-.07a.16.16,0,0,1-.14-.12Zm-2.09-.35h2l-.39-2.72Z"
      ></path>
      <path
        d="M220,354.93l-2.13,2.25a.22.22,0,0,1-.17.08h0c-.07,0-.11,0-.13-.08l-1.11-2.24-.95,4.15a.24.24,0,0,1-.22.18.14.14,0,0,1-.14-.18l1.08-4.68a.28.28,0,0,1,.11-.13v0a.17.17,0,0,1,.24.05l1.22,2.49,2.37-2.49a.19.19,0,0,1,.25-.05.21.21,0,0,1,0,.06.14.14,0,0,1,0,.09l-1.08,4.68a.23.23,0,0,1-.21.18.14.14,0,0,1-.14-.18Z"
      ></path>
      <path
        d="M69.1,319.78A5.08,5.08,0,0,1,65.38,318c-1-1.15-2.41-3.79-1-8.58,1.33-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.63,6.54a1.18,1.18,0,0,1-1.3,1.1,1.22,1.22,0,0,1-1.1-1.31c.19-2.21-.46-3.73-1.68-4-1.38-.26-3.34,1.07-4.24,4.06-.82,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2.05,1,1.21,1.21,0,1,1,.33,2.39A4,4,0,0,1,69.1,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M84,319.78A5.06,5.06,0,0,1,80.24,318c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.63,6.54a1.19,1.19,0,0,1-1.3,1.1A1.22,1.22,0,0,1,87.5,310c.19-2.21-.46-3.73-1.68-4-1.39-.26-3.34,1.07-4.24,4.06-.83,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2.05,1,1.21,1.21,0,1,1,.33,2.39A4.07,4.07,0,0,1,84,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M98.81,319.78A5.06,5.06,0,0,1,95.1,318c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.63,6.54a1.19,1.19,0,0,1-1.3,1.1,1.21,1.21,0,0,1-1.1-1.31c.19-2.21-.46-3.73-1.69-4s-3.33,1.07-4.23,4.06c-.83,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2,1,1.21,1.21,0,1,1,.33,2.39A4.07,4.07,0,0,1,98.81,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M113.67,319.78A5,5,0,0,1,110,318c-1-1.15-2.42-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.64,6.54a1.2,1.2,0,1,1-2.4-.21c.18-2.21-.46-3.73-1.69-4s-3.33,1.07-4.23,4.06c-.83,2.73-.65,5,.49,6.31a2.51,2.51,0,0,0,2,1,1.21,1.21,0,1,1,.33,2.39A4.19,4.19,0,0,1,113.67,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M128.53,319.78a5.08,5.08,0,0,1-3.72-1.83c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.64,6.54a1.2,1.2,0,1,1-2.4-.21c.18-2.21-.46-3.73-1.69-4s-3.33,1.07-4.23,4.06c-.83,2.73-.66,5,.49,6.31a2.5,2.5,0,0,0,2,1,1.21,1.21,0,1,1,.33,2.39A4.19,4.19,0,0,1,128.53,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M143.39,319.78a5.08,5.08,0,0,1-3.72-1.83c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.64,6.54a1.2,1.2,0,0,1-1.31,1.1,1.22,1.22,0,0,1-1.1-1.31c.19-2.21-.45-3.73-1.68-4-1.38-.26-3.34,1.07-4.24,4.06-.82,2.73-.65,5,.49,6.31a2.53,2.53,0,0,0,2.05,1,1.21,1.21,0,0,1,.33,2.39A3.91,3.91,0,0,1,143.39,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M158.25,319.78a5.08,5.08,0,0,1-3.72-1.83c-1-1.15-2.41-3.79-1-8.58,1.33-4.39,4.53-6.2,7-5.73,1.9.36,4,2.29,3.64,6.54a1.2,1.2,0,0,1-1.31,1.1,1.22,1.22,0,0,1-1.1-1.31c.19-2.21-.46-3.73-1.68-4-1.38-.26-3.34,1.07-4.24,4.06-.82,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2,1,1.21,1.21,0,1,1,.33,2.39A4,4,0,0,1,158.25,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M173.11,319.78a5.08,5.08,0,0,1-3.72-1.83c-1-1.15-2.41-3.79-1-8.58,1.33-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.63,6.54a1.18,1.18,0,0,1-1.3,1.1,1.22,1.22,0,0,1-1.1-1.31c.19-2.21-.46-3.73-1.68-4-1.38-.26-3.34,1.07-4.24,4.06-.82,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2.05,1,1.21,1.21,0,0,1,.33,2.39A4,4,0,0,1,173.11,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M188,319.78a5.06,5.06,0,0,1-3.71-1.83c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.63,6.54a1.19,1.19,0,0,1-1.3,1.1,1.21,1.21,0,0,1-1.1-1.31c.19-2.21-.46-3.73-1.69-4s-3.33,1.07-4.23,4.06c-.83,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2,1,1.21,1.21,0,1,1,.33,2.39A4.07,4.07,0,0,1,188,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M202.82,319.78a5,5,0,0,1-3.71-1.83c-1-1.15-2.42-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.91.36,4,2.29,3.64,6.54a1.19,1.19,0,0,1-1.3,1.1,1.21,1.21,0,0,1-1.1-1.31c.18-2.21-.46-3.73-1.69-4-1.38-.26-3.33,1.07-4.23,4.06-.83,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2.05,1,1.21,1.21,0,0,1,.33,2.39A4.07,4.07,0,0,1,202.82,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M217.68,319.78A5.08,5.08,0,0,1,214,318c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.64,6.54a1.19,1.19,0,0,1-1.3,1.1,1.2,1.2,0,0,1-1.1-1.31c.18-2.21-.46-3.73-1.69-4s-3.33,1.07-4.23,4.06c-.83,2.73-.65,5,.49,6.31a2.51,2.51,0,0,0,2,1,1.21,1.21,0,1,1,.33,2.39A4.19,4.19,0,0,1,217.68,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M232.54,319.78a5.08,5.08,0,0,1-3.72-1.83c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.64,6.54a1.2,1.2,0,1,1-2.4-.21c.18-2.21-.46-3.73-1.69-4-1.38-.26-3.33,1.07-4.24,4.06-.82,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2,1,1.21,1.21,0,0,1,.34,2.39A4.19,4.19,0,0,1,232.54,319.78Z"
        style="fill:#a6a6a6"
      ></path>
      <path
        d="M247.4,319.78a5.08,5.08,0,0,1-3.72-1.83c-1-1.15-2.41-3.79-1-8.58,1.32-4.39,4.52-6.2,7-5.73,1.9.36,4,2.29,3.64,6.54a1.2,1.2,0,0,1-1.31,1.1,1.22,1.22,0,0,1-1.1-1.31c.19-2.21-.46-3.73-1.68-4-1.38-.26-3.33,1.07-4.24,4.06-.82,2.73-.65,5,.49,6.31a2.52,2.52,0,0,0,2.05,1,1.21,1.21,0,0,1,.33,2.39A3.91,3.91,0,0,1,247.4,319.78Z"
        style="fill:#a6a6a6"
      ></path>
    </g>
    <g id="freepik--Plant--inject-7">
      <path
        d="M414.77,330.26a78.59,78.59,0,0,1,1.81-12.76,28.4,28.4,0,0,1,4.56-10.76,13.69,13.69,0,0,1,8.94-5.57c3.5-.43,6.78,1.13,9.4,3.34,3.25,2.73,5.73,6.35,8.06,9.85a119.36,119.36,0,0,1,7,12.19.12.12,0,0,1-.21.11,75.19,75.19,0,0,0-6.22-10.19,63.46,63.46,0,0,0-7.17-8.68c-2.4-2.35-5.46-4.54-8.94-4.65a11,11,0,0,0-8.74,4.5c-2.34,3-3.52,6.71-4.41,10.35A76.4,76.4,0,0,0,417,330.14c-.69,8.4-.87,16.86-1.06,25.29q-.16,7.15-.22,14.31l-.06,7.25a44.05,44.05,0,0,1-.28,7,.48.48,0,0,1-.92,0,40.75,40.75,0,0,1-.32-6.63q-.06-3.43-.09-6.87-.06-6.68-.05-13.36C414.05,348.16,414.16,339.18,414.77,330.26Z"
        style="fill:#263238"
      ></path>
      <path
        d="M426.78,323.93c.45-2.38,1.25-5.48,2.6-7.32,2.44-3.31,5.06-1.87,2.63,1.79a21.89,21.89,0,0,0-3.41,9s4.09,5.84,9,8.72c-.21-2.25-.85-5.7-.41-9,.95-7.21,5.31-6.81,4.23-1.07a49.62,49.62,0,0,0-1,11.59,24.54,24.54,0,0,0,5.27,2.59c-.28-.84-.58-1.84-.91-3.06-1.76-6.47,2.56-8.49,2.7-4.85a50.09,50.09,0,0,0,1.68,9.18c2.37.8,4.33,1.34,5.53,1.76a20.13,20.13,0,0,1,8.09,5.53,25.43,25.43,0,0,0,5.52-7.13c-1.51-1.3-3.89-3.23-7.2-5.57-6.21-4.38-4-9.91.87-6.47,3.55,2.48,6.3,7.08,7.55,9.44a38.13,38.13,0,0,0,2.82-12.92c-4.88-4.57-16.93-10.95-13.3-10.95,3.27,0,10.59,4.79,13.27,6.64a34.41,34.41,0,0,0-.41-3.75c-4.59-3-19.51-7.69-17.13-9,2.61-1.47,13,3.34,16.16,4.87a18.73,18.73,0,0,0-2.75-5.71c-6.35-8.49-17.78-11.42-22.77-9.8-3.53,1.14-2.5,10.1-3.26,9.8C428,302.49,421.56,306.52,426.78,323.93Zm34.77-1c1-1.21,5.66,2.36,4.32,4.32S460.25,324.5,461.55,322.94Zm-24.32-7.64c1.22.78-.59,5.31-2.48,3.94C433.15,318.07,436,314.52,437.23,315.3Z"
        style="fill:#6CBD45"
      ></path>
      <path
        d="M439.08,316.69c.64-1.27,1.31-2.52,2-3.74a22.12,22.12,0,0,1,2.35-3.4l-.61-.75c-.08-.1.06-.24.15-.14.24.27.46.55.69.83a.18.18,0,0,1,.1.11c.88,1,1.7,2.13,2.49,3.24a36.61,36.61,0,0,1,4.12,1.19c1.39.47,2.77,1,4.12,1.52.15.06.08.3-.07.23-1.33-.59-2.69-1.16-4.08-1.63s-2.65-.79-4-1.16c.43.61.85,1.22,1.26,1.85a49.08,49.08,0,0,1,7.29,3c2.46,1.17,4.83,2.53,7.19,3.89.13.08,0,.29-.13.21a79.22,79.22,0,0,0-7.15-3.7c-2.28-1.07-4.64-1.95-6.94-3,5.79,9,9.26,19.48,13.91,29.13.07.14-.15.26-.21.12-1.42-3.39-3.05-6.69-4.6-10-1.38-3-2.74-6-4.13-9-.4-.87-.82-1.75-1.24-2.62.25,4.83.15,9.74.94,14.51a.12.12,0,1,1-.24,0c-.33-5.16-1.24-10.24-1.21-15.43,0,0,0,0,0-.07q-1.47-3-3.16-5.81c-1.92,4.52-3.94,9.11-4.83,14,0,.15-.27.08-.23-.07,1.3-4.86,2.51-9.73,4.86-14.23a55.49,55.49,0,0,0-4.08-5.88c-.65,1.2-1.47,2.34-2.2,3.48s-1.42,2.25-2.08,3.41a48.32,48.32,0,0,0-3.63,7.66c-.05.14-.29.07-.23-.07C436.7,321.77,437.82,319.19,439.08,316.69Z"
        style="fill:#263238"
      ></path>
      <path
        d="M397.85,330.69c3.19-4.19,6.82-9.61,12.52-10.37,5.5-.73,10.13,3.16,13.07,7.41,3.07,4.45,4.67,9.74,6.06,14.9a187.91,187.91,0,0,1,4,18.79c.58,3.51,1,7,1.42,10.57a70.74,70.74,0,0,1,.63,10.78c0,.58-.94.73-1.06.12-.56-2.95-.84-5.95-1.22-8.92s-.82-5.84-1.32-8.75c-1-5.89-2.23-11.73-3.71-17.51-1.3-5.06-2.49-10.27-4.69-15-2-4.29-5.27-9.05-10.06-10.41-6.55-1.85-11.94,3.86-15.43,8.54C398,330.94,397.76,330.81,397.85,330.69Z"
        style="fill:#263238"
      ></path>
      <path
        d="M377.37,337h0c0,.76,0,1.52,0,2.26a13.27,13.27,0,0,1,6.2-2.23c5.3-.31,4.77,3.68,1.24,3.68a20.14,20.14,0,0,0-7.3,1.1c.53,7,2.18,12.69,2.46,12.78a102.86,102.86,0,0,0,14-1.1c-1.18-2.85-4-6.71-2.45-6.93s3,3.15,3.71,6.74A67.17,67.17,0,0,0,405.52,351c-2.22-2.11-5.68-4.78-4.26-5.78s4.09,2.65,5.67,5.29a20.52,20.52,0,0,0,4.5-2.23c-2.91-4.74-10.47-6-9.32-9.31s8.05,1.67,11,8c3.94-3.72,5.3-9.17,5.13-13.9-3.25-.54-9.58-.15-9-2.48s5.09-1.66,8.75-.11a13,13,0,0,0-1.94-5.28c-3.23-4.59-14,.53-14,.53s1.63-10.52-2.3-12.54c-2.26-1.16-6.34-1.34-10.55.87,2.29.3,5,1.16,6.07,2.81,1.33,2.1-1,3.1-2.36,2.09-1-.71-2.76-2.89-6.14-3.33a20.85,20.85,0,0,0-4,4,20.38,20.38,0,0,0-1.19,1.7,14.41,14.41,0,0,1,12.3.81c4.45,2.48,1.68,7.09-2.16,5.07s-7.48-4-11.69-3.17a29.48,29.48,0,0,0-2.57,11.69,21,21,0,0,1,6.91-2.92c4.6-1,5.84,1.8.83,2.07A20,20,0,0,0,377.37,337Zm5.86-7c-.24-1.49,3-1.76,3.48-.54C387.1,330.46,383.47,331.44,383.23,330Zm27.13,9.45c.34-.79,2.45.22,2.2,1.21C412.23,341.94,410,340.19,410.36,339.41Zm-15.44,4.42c1.6-.55,3.86,3.47,2.11,4.28S393.62,344.29,394.92,343.83Z"
        style="fill:#6CBD45"
      ></path>
      <path
        d="M377.37,337h0c0,.76,0,1.52,0,2.26a13.27,13.27,0,0,1,6.2-2.23c5.3-.31,4.77,3.68,1.24,3.68a20.14,20.14,0,0,0-7.3,1.1c.53,7,2.18,12.69,2.46,12.78a102.86,102.86,0,0,0,14-1.1c-1.18-2.85-4-6.71-2.45-6.93s3,3.15,3.71,6.74A67.17,67.17,0,0,0,405.52,351c-2.22-2.11-5.68-4.78-4.26-5.78s4.09,2.65,5.67,5.29a20.52,20.52,0,0,0,4.5-2.23c-2.91-4.74-10.47-6-9.32-9.31s8.05,1.67,11,8c3.94-3.72,5.3-9.17,5.13-13.9-3.25-.54-9.58-.15-9-2.48s5.09-1.66,8.75-.11a13,13,0,0,0-1.94-5.28c-3.23-4.59-14,.53-14,.53s1.63-10.52-2.3-12.54c-2.26-1.16-6.34-1.34-10.55.87,2.29.3,5,1.16,6.07,2.81,1.33,2.1-1,3.1-2.36,2.09-1-.71-2.76-2.89-6.14-3.33a20.85,20.85,0,0,0-4,4,20.38,20.38,0,0,0-1.19,1.7,14.41,14.41,0,0,1,12.3.81c4.45,2.48,1.68,7.09-2.16,5.07s-7.48-4-11.69-3.17a29.48,29.48,0,0,0-2.57,11.69,21,21,0,0,1,6.91-2.92c4.6-1,5.84,1.8.83,2.07A20,20,0,0,0,377.37,337Zm5.86-7c-.24-1.49,3-1.76,3.48-.54C387.1,330.46,383.47,331.44,383.23,330Zm27.13,9.45c.34-.79,2.45.22,2.2,1.21C412.23,341.94,410,340.19,410.36,339.41Zm-15.44,4.42c1.6-.55,3.86,3.47,2.11,4.28S393.62,344.29,394.92,343.83Z"
        style="opacity:0.1"
      ></path>
      <path
        d="M380.64,353.79c2.55-3.84,5.08-7.7,7.75-11.46q1.86-2.62,3.87-5.14l-.55-.16-.94-.22c-.72-.16-1.44-.3-2.17-.41a20.76,20.76,0,0,0-2.07-.22,11,11,0,0,0-2.22,0c-.09,0-.1-.12,0-.12.74.07,1.5,0,2.24,0s1.44.08,2.15.16,1.34.17,2,.3l1.09.25a4.91,4.91,0,0,1,.66.17q2.06-2.55,4.23-5a47.27,47.27,0,0,0-12.74-4.74c-.07,0,0-.13,0-.12a44,44,0,0,1,12.93,4.61c.8-.89,1.6-1.78,2.41-2.66s1.87-1.95,2.69-3c.06-.07.16,0,.1.07a46.46,46.46,0,0,0-3.18,3.53h0a46.05,46.05,0,0,1,4.63,4.09c1.5,1.47,3,3,4.39,4.53.05.06,0,.14-.09.09-1.4-1.54-2.86-3-4.4-4.41s-3.15-2.71-4.7-4.1v0l-1.17,1.39c-.19.24-.39.47-.59.7a.1.1,0,0,1,0,.05L395,334.33a19.4,19.4,0,0,1,1.67,3.39c.48,1.14.88,2.31,1.25,3.49a50.34,50.34,0,0,1,1.62,7.5c0,.07-.11.1-.12,0a43.31,43.31,0,0,0-1.8-7.37c-.4-1.23-.87-2.43-1.35-3.63s-1-2.15-1.4-3.25l-1.68,2.05-.47.61a.07.07,0,0,1-.06.1h0c-1.73,2.19-3.39,4.44-5,6.71a2.37,2.37,0,0,1,.18.53c.08.28.16.58.23.87a18,18,0,0,1,.33,1.78c.07.56.12,1.13.15,1.69a15.29,15.29,0,0,0,.05,1.92c0,.1-.14.1-.11,0a6.71,6.71,0,0,0-.05-1.79c-.06-.62-.14-1.23-.25-1.84s-.23-1.09-.36-1.63c-.07-.28-.14-.55-.22-.81s-.11-.3-.15-.45c-.75,1.07-1.5,2.14-2.24,3.23-1.47,2.14-2.92,4.29-4.38,6.44C380.74,354,380.57,353.9,380.64,353.79Z"
        style="fill:#263238"
      ></path>
      <path
        d="M413.73,376.54c.06-2,.37-3.94.58-5.89s.43-3.92.64-5.89a89.81,89.81,0,0,1,1.52-11.34,16.5,16.5,0,0,1,4.62-8.49,7.49,7.49,0,0,1,4.53-2.16,7.74,7.74,0,0,1,4.8,1.48,16.75,16.75,0,0,1,4.05,4.26,42.62,42.62,0,0,1,3.15,5.12c0,.07-.07.11-.11,0a26.22,26.22,0,0,0-6.82-7.64,8.07,8.07,0,0,0-4.3-1.79,5.84,5.84,0,0,0-4.17,1.66,15.67,15.67,0,0,0-4.4,7.79,78.78,78.78,0,0,0-1.7,10.49q-.42,3.1-.82,6.23c-.27,2.06-.45,4.18-.88,6.22A.35.35,0,0,1,413.73,376.54Z"
        style="fill:#263238"
      ></path>
      <path
        d="M423.39,361.29a11,11,0,0,0,2.13,2.19c-.32-1.92-.71-5.32.26-7.13,1.5-2.82,3.27-1.42,2.38,1a20,20,0,0,0-1.45,6.94,30.32,30.32,0,0,0,6.52,3.07A11.13,11.13,0,0,1,433,364c.3-3,2.6-3,2,.17a19.66,19.66,0,0,0-.31,3.68,67.15,67.15,0,0,0,10.16,2.29,29.67,29.67,0,0,0,4.2-7.49c-2.44-.61-7.4-.75-7.3-2.5.14-2.35,5-.54,7.76,1.17a18.68,18.68,0,0,0,.84-6.34,31.81,31.81,0,0,0-6.75-1.12c-5-.43-4.79-3.29-1.14-3.22,2.7.05,6.11,1.7,7.72,2.55-1.05-6.85-6.28-11.25-10.47-11.42-7.05-.28-4.52,8.49-4.52,8.49s-4.78-3.36-9.28-3.27S418.57,354.59,423.39,361.29Zm18.83-12.68c-.16-1,3-1.22,3.15,0C445.56,350.07,442.38,349.62,442.22,348.61Zm5.06,10.29c-.06-.64,1.3-.75,1.6.06C449.09,359.49,447.34,359.54,447.28,358.9Zm-16.93.6c1.06.15,1.67,3.95-.16,3.88C428.79,363.32,429.45,359.38,430.35,359.5Z"
        style="fill:#6CBD45"
      ></path>
      <path
        d="M431.82,363.72c.18-.47.33-1,.48-1.43-.13.49-.26,1-.35,1.47A.07.07,0,1,1,431.82,363.72Z"
        style="fill:#263238"
      ></path>
      <path
        d="M433.68,357.62c.33-1,.7-1.94,1.08-2.9.21-.51.41-1,.64-1.51a5.86,5.86,0,0,1,.63-1.28,8.53,8.53,0,0,1-.57-1.23s0-.07.06,0a13.11,13.11,0,0,1,1.37,2.13c.2.33.39.67.58,1a9.81,9.81,0,0,1,1.19.19c.42.07.84.16,1.26.25l1.26.3c.41.09.82.23,1.25.3.09,0,.05.17,0,.13a8.55,8.55,0,0,0-1.32-.35c-.4-.08-.81-.15-1.22-.21l-1.23-.15-.93-.08c.16.3.34.59.5.89,0,0,.05.09.08.14a3.83,3.83,0,0,1,1,.12c.36.06.73.13,1.09.21.73.17,1.47.34,2.19.54,1.53.43,3,.92,4.54,1.41.08,0,0,.15-.05.12a45.28,45.28,0,0,0-4.56-1.26c-.72-.16-1.44-.33-2.17-.48l-1.08-.23a6.14,6.14,0,0,1-.85-.19c.78,1.44,1.51,2.89,2.18,4.38,1.46,3.23,2.7,6.57,3.95,9.89,0,.08-.1.13-.13,0a89.94,89.94,0,0,0-4.2-9.67l-.85-1.71a3.59,3.59,0,0,0-.08.35l-.21,1.18c-.13.78-.26,1.57-.38,2.36a27.88,27.88,0,0,0-.57,4.9c0,.1-.15.09-.13,0,.12-.78.12-1.6.17-2.39s.11-1.65.21-2.47.19-1.58.32-2.37l.21-1.18a2.43,2.43,0,0,1,.22-.85c-.41-.83-.82-1.66-1.24-2.49s-.79-1.54-1.19-2.31c-.17-.33-.35-.66-.53-1a12.26,12.26,0,0,1-.47,1.19c-.18.44-.36.89-.55,1.33-.4,1-.78,2-1.15,3-.54,1.41-1.13,2.86-1.56,4.33C432.84,360.51,433.2,359,433.68,357.62Z"
        style="fill:#263238"
      ></path>
      <path
        d="M432.3,362.29c0-.12.07-.23.11-.34C432.37,362.06,432.34,362.17,432.3,362.29Z"
        style="fill:#263238"
      ></path>
      <polygon
        points="397.6 377.11 398.46 389.78 400.68 422.44 449.08 422.44 451.29 389.78 452.15 377.11 397.6 377.11"
        style="fill:#37474f"
      ></polygon>
      <polygon
        points="397.6 377.11 398.46 389.78 451.29 389.78 452.15 377.11 397.6 377.11"
        style="fill:#263238"
      ></polygon>
      <rect
        x="394.16"
        y="371.99"
        width="61.43"
        height="10.24"
        transform="translate(849.75 754.22) rotate(180)"
        style="fill:#37474f"
      ></rect>
      <rect
        x="436.66"
        y="422.44"
        width="8.5"
        height="5.36"
        style="fill:#37474f"
      ></rect>
      <rect
        x="436.66"
        y="422.44"
        width="8.5"
        height="2.68"
        style="fill:#263238"
      ></rect>
      <rect
        x="404.59"
        y="422.44"
        width="8.49"
        height="5.36"
        style="fill:#37474f"
      ></rect>
      <rect
        x="404.59"
        y="422.44"
        width="8.49"
        height="2.68"
        style="fill:#263238"
      ></rect>
    </g>
    <g id="freepik--speech-bubble--inject-7">
      <path
        d="M385.92,117.17a24.77,24.77,0,0,1-41.41,15.68l-12.4,1.82,6.2-10.72a24.51,24.51,0,0,1-1.7-11.93,24.79,24.79,0,1,1,49.31,5.15Z"
        style="fill:#fff"
      ></path>
      <path
        d="M385.92,117.17a25,25,0,0,1-5,12.57,29.06,29.06,0,0,1-2.25,2.58,27.69,27.69,0,0,1-2.62,2.22,24.33,24.33,0,0,1-6,3.33A24.16,24.16,0,0,1,360,139.53a21.93,21.93,0,0,1-3.43-.36,25,25,0,0,1-12.27-6.06l.3.09-12.39,1.91-.9.13.46-.79,6.16-10.74,0,.42a25.09,25.09,0,0,1,31.08-33.29,25.45,25.45,0,0,1,9.56,5.86A25,25,0,0,1,385.92,117.17Zm0,0a24.53,24.53,0,0,0-28.11-26.82,24.33,24.33,0,0,0-10.24,4,25.59,25.59,0,0,0-7.41,8.09,24.41,24.41,0,0,0-1.4,21.29l.08.22-.11.2-6.24,10.7-.45-.65,12.41-1.74.18,0,.12.12a24.35,24.35,0,0,0,11.87,6.11,19.9,19.9,0,0,0,3.36.41,24,24,0,0,0,3.39,0,24.22,24.22,0,0,0,6.62-1.46,23.5,23.5,0,0,0,6-3.22,28.67,28.67,0,0,0,2.62-2.19,26.08,26.08,0,0,0,2.25-2.56A24.85,24.85,0,0,0,385.92,117.17Z"
        style="fill:#263238"
      ></path>
      <polygon
        points="358.36 128.73 347.78 118.02 351.33 114.5 357.52 120.76 370.37 100.62 374.58 103.31 358.36 128.73"
        style="fill:#6CBD45"
      ></polygon>
    </g>
  </svg>
</template>

<script setup lang="ts">
defineOptions({
  name: 'NoPlanSvg'
});
</script>
